(() => {
  if (document.documentElement.dataset.gutsuppGuaranteeReady) return;
  document.documentElement.dataset.gutsuppGuaranteeReady = 'true';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('main a[href]');
    const linkUrl = link ? new URL(link.href, window.location.href) : null;
    const policyLink = linkUrl?.origin === window.location.origin && linkUrl.pathname === '/policies/refund-policy' ? link : null;
    const trigger = event.target.closest('[data-guarantee-open]') || policyLink;
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls')) || document.querySelector('dialog.gutsupp-guarantee-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-guarantee-close]');
    if (close) close.closest('dialog')?.close();
    const dialog = event.target;
    if (dialog.matches?.('dialog.gutsupp-guarantee-dialog')) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
  });
})();
